<div class="container">
  <div class="container__title">
    <p class="title" [innerHTML]="'order.ship.on' | translate"></p>
  </div>
  <div class="container__date">
    <p class="date">{{ shippingDate | async }}</p>
  </div>
</div>
